// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NBjQ","index":"styles_index__1lONf"};